import React from 'react';
import { useCookies } from 'react-cookie';
import { useTheme } from 'ThemeContext';

import Modal from 'components/Modal';
import Widgets from 'components/Widgets';

import { Wrapper } from './Popup.style';

function Popup({ data }) {
  const theme = useTheme();
  const [cookies, setCookie] = useCookies(['APP_POPUP']);
  return (
    <>
      {cookies && !cookies['APP_POPUP'] ? (
        <Modal
          visibleModal={true}
          setVisibleModal={() => {
            setCookie('APP_POPUP', true, { path: '/' });
          }}
        >
          <Wrapper theme={theme.popup.wrapper}>
            <Widgets widgets={data} />
          </Wrapper>
        </Modal>
      ) : (
        ''
      )}
    </>
  );
}

export default Popup;
